/**
 * @param props
 * @param props.isGiftCard
 * @param props.amount
 * @param props.isSelectedVariantOutOfStock
 * @param props.isSelectedVariantSampledAndRated
 * @param props.needsToBeRatedSample
 * @param props.shouldShowAovLock
 * @param props.notDeliveredYet
 * @param props.isFullSizeDiscount
 * @returns {boolean}
 */
const isDisabledQuickShopProductButtonSelectorUtil = ({
  isGiftCard,
  amount,
  isSelectedVariantOutOfStock,
  isSelectedVariantSampledAndRated,
  needsToBeRatedSample,
  shouldShowAovLock,
  notDeliveredYet,
  isFullSizeDiscount
}) => {
  if (
    !needsToBeRatedSample &&
    shouldShowAovLock
  ) {
    return true
  }

  if (notDeliveredYet) {
    return true
  }

  if (isFullSizeDiscount) {
    return true
  }

  if (isSelectedVariantSampledAndRated) {
    return true
  }

  if (
    isGiftCard &&
    !amount
  ) {
    return true
  }

  if (
    isSelectedVariantOutOfStock &&
    !needsToBeRatedSample
  ) {
    return true
  }

  return false
}

export default isDisabledQuickShopProductButtonSelectorUtil
